import type { ExerciseMuscleIntensity } from 'fitify-types/src/types/exercise-collection'

import type { MuscleRegion } from '@/components/exercises/Exercise/Muscles/MuscleMap/MuscleMap.Utils'
import { Region } from '@/components/exercises/Exercise/Muscles/MuscleMap/Region'

type Props = {
  grayDetailsPath: string
  groupTransform?: string
  intensity?: ExerciseMuscleIntensity
  intensityStretch?: ExerciseMuscleIntensity
  lightDetailsPath: string
  muscleRegions: MuscleRegion[]
  outlinePath: string
}

export const Body = ({
  grayDetailsPath,
  groupTransform,
  intensity,
  intensityStretch,
  lightDetailsPath,
  muscleRegions,
  outlinePath,
}: Props) => {
  return (
    <g transform={groupTransform}>
      {/* Silhouette outline */}
      <path
        d={outlinePath}
        fill="rgba(0,0,0,0.05)"
        fillRule="evenodd"
        stroke="none"
      />
      {/* Anatomical detail lines - gray */}
      <path
        d={grayDetailsPath}
        fill="#D8D8D8"
        fillRule="evenodd"
        opacity={0.4}
      />
      {/* Anatomical detail lines - light */}
      <path d={lightDetailsPath} fill="#E8E8E8" fillRule="evenodd" />
      {/* Muscle overlays */}
      {muscleRegions.map((region) => {
        return (
          <Region
            key={region.key}
            muscleIntensity={intensity?.[region.key]}
            region={region}
            stretchIntensity={intensityStretch?.[region.key]}
          />
        )
      })}
    </g>
  )
}
